<template>
  <div class="personal-attendance-select-container">
    <div class="content">
      <div class="operation">
        <el-form :inline="true" @submit.native.prevent label-width="84px">
          <el-form-item label="开始日期">
            <el-date-picker
              v-model="params.startTime"
              type="date"
              placeholder="请输入日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker
              v-model="params.endTime"
              type="date"
              placeholder="请输入日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item v-if="showOperation" label="选择员工">
            <el-autocomplete
              popper-class="cust-input"
              v-model="params.name"
              :fetch-suggestions="querySearch"
              placeholder="请搜索员工"
              @select="handleSelect"
              value-key="name"
            >
              <template slot-scope="{ item }">
                <div v-if="!item.message">{{ item.jobNum }}-{{ item.name }}-{{ item.departmentName }}-{{ item.postName }}</div>
                <div v-else>{{ item.message }}</div>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item label=" " label-width="0">
            <el-dropdown size="mini" split-button trigger="click" @click="search" class="search-dropdown">
              查询
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><div @click="resetData">重置</div></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table
          ref="table"
          :data="tableData"
          height="calc(100% - 40px)"
          v-loading="loading"
          header-row-class-name="header-class"
        >
          <el-table-column
            v-for="column in columns"
            :key="column.id"
            :prop="column.id"
            :label="column.name"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'personalAttendanceSelect',
  props: {
    showOperation: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      tableData: [],
      columns: [
        {id: 'date', name: '日期'},
        {id: 'week', name: '星期'},
        {id: 'onTime', name: '上班'},
        {id: 'offTime', name: '下班'}
      ],
      params: {
        startTime: '',
        endTime: '',
        name: ''
      },
      pagination: {
        currentPage: 0,
        pageSize: 20,
        pageSizes: [10, 20, 30, 50, 100],
        total: 0
      },
      selectList: [],
      selectUserId: ''
    }
  },
  methods: {
    loadSelectData () {
      return this.$axios.get('/system-api/attendanceReport/getSelectPeopleList').then(({data}) => {
        this.selectList = data.data || []
      })
    },
    getUserInfo () {
      return this.$axios.get('/auth-api/oauth/currentUserInfo').then(res => {
        this.params.name = res.data.name
        this.selectUserId = res.data.id
      })
    },
    loadData () {
      !this.loading && (this.loading = true)
      let params = {
        startDate: this.params.startTime,
        endDate: this.params.endTime,
        userId: this.selectUserId
      }
      return this.$axios.post('/system-api/attendanceReport/getAttendanceReportList', params).then(({data}) => {
        if (data && data.data) {
          this.tableData = data.data || []
          this.$nextTick(() => (this.loading = false))
        } else {
          this.loading = false
        }
      })
    },
    resetData () {
      this.params.startTime = ''
      this.params.endTime = ''
      this.params.name = ''
      // 只有考勤管理需要请空
      if (this.showOperation) {
        this.selectUserId = ''
      }
      this.$nextTick(() => this.loadData())
    },
    dateAdd (interval, date) {
      interval.y && date.setFullYear(date.getFullYear() + interval.y)
      interval.m && date.setMonth(date.getMonth() + interval.m)
      interval.d && date.setDate(date.getDate() + interval.d)
      return `${date.getFullYear()}-${this.setZero(date.getMonth() + 1)}-${this.setZero(date.getDate())}`
    },
    setZero (number) {
      return parseInt(number) < 10 ? '0' + number : number
    },
    handleSelect (item) {
      if (!item.message) {
        this.selectUserId = item.id
      } else {
        // 如果是没有查到该人，点击选中应该清空数据
        this.params.name = ''
        this.selectUserId = ''
      }
    },
    querySearch (str, callback) {
      let arr = []
      str && str.trim() !== '' && (arr = this.selectList.filter(e => e.name && e.name.indexOf(str) !== -1))
      if (arr.length === 0 && str) {
        arr.push({message: '查无此人'})
        callback(arr)
      } else {
        callback(arr)
      }
    },
    search () {
      // 判断间隔是否为一个月
      let start = new Date(this.params.startTime)
      let end = new Date(this.params.endTime)
      if ((new Date(end - start).getTime() / (24 * 60 * 60 * 1000) + 1) > 31) {
        this.$message.error('开始时间与结束时间必须间隔一个月之内')
      } else {
        this.loadData()
      }
    }
  },
  created () {
    // 默认时间为当月1号-当前
    this.params.endTime = this.dateAdd({}, new Date())
    this.params.startTime = this.dateAdd({d: -(parseInt(new Date().getDate()) - 1)}, new Date())
    this.$nextTick(async () => {
      this.loading = true
      await this.loadSelectData()
      // 默认选中当前登录人
      await this.getUserInfo()
      this.loadData()
    })
  },
  watch: {
    'params.startTime' (newVal, oldVal) {
      if (newVal && this.params.endTime) {
        let start = new Date(newVal)
        let end = new Date(this.params.endTime)
        if (start.getTime() > end.getTime()) {
          this.$message.error('开始时间必须小于结束时间')
          this.params.startTime = oldVal
        }
      }
    },
    'params.endTime' (newVal, oldVal) {
      if (newVal && this.params.startTime) {
        let end = new Date(newVal)
        let start = new Date(this.params.startTime)
        if (start.getTime() > end.getTime()) {
          this.$message.error('开始时间必须大于结束时间')
          this.params.endTime = oldVal
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .personal-attendance-select-container {
    height: 100%;
    background-color: #fff;

    .header-class {
      th {
        background-color: rgb(248, 248, 248);

        .cell {
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #706c6a;
        }
      }
    }

    .el-pagination {
      text-align: right;
      padding-top: 5px;
    }

    .cust-table {
      .search {
        padding: 10px 0;

        .el-input {
          width: 200PX;
        }
      }
      .table {
        height: 427px;
      }
    }

    & > .content {
      padding-top: 12px;
      height: 100%;

      .operation {
        .el-button--mini,
        .el-button--mini.is-round {
          border: 1px solid #55ACF1;
          color: #55ACF1;
          padding: 5px;
          vertical-align: middle;
        }
        .search-dropdown {
          height: 30px;
          line-height: 30px;

          span {
            font-size: 12px;
          }
          .el-dropdown__caret-button {
            width: 21px;
            padding: 5px 2px;
            border-left: transparent;
            .el-icon-arrow-down {
              margin: 0;
            }
            &::before {
              background: #55ACF1;
            }
          }
        }
      }

      .table {
        height: calc(100% - 55px);

        .el-table {
          .el-table__body-wrapper {
            .el-table__body {
              .el-table__row {
                td {
                  .cell {
                    font-size: 12px;
                    font-family: MicrosoftYaHei;
                    font-weight: 400;
                    color: #4a494e;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .cust-input {
    width: auto!important;
    min-width: 178px;
  }
</style>



// WEBPACK FOOTER //
// src/components/system/system/personal-attendance-select.vue